import React from 'react';
import { Empty } from 'antd';
import { SharedMTSummaryReport } from './templates/SharedMTSummaryReport';
import { resolveMTConfig } from './reportConfigResolver';

export function MTSummaryReport(props) {
   const config = resolveMTConfig(props.template, props.subject_id);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedMTSummaryReport {...props} config={config} />;
}
